import TEMPLATE_URL from "emun.products/parser/product-parser.htm";
import controller from "emun.products/parser/product-parser.controller";
import modals from "webmodals/modals";

const NOOP = () => {};

export default ({
  size = "md",
  backdrop = "static",
  templateUrl = TEMPLATE_URL,
  title = "Product Bulk Pad...",
  subTitle = "Enter products separated by comma or white-space",
  view = "cards",
  returnProducts = false,
  onParsed = NOOP,
  onResolved = NOOP
} = {}) =>
  modals.open({
    size,
    backdrop,
    templateUrl,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => ({
        title,
        subTitle,
        returnProducts,
        onParsed,
        onResolved,
        view
      })
    }
  }).result;
